import React, { useEffect, useState } from "react";
import { Phone, ChevronDown, UtensilsCrossed, Truck } from "lucide-react";
import { restaurantInfo } from "../data/mock";
import { useLanguage } from "../context/LanguageContext";

export default function HeroCarousel({ onReserve }) {
  const { t } = useLanguage();
  const [idx, setIdx] = useState(0);

  const heroImages = [
    "/images/hq_entrance.jpg",
    "/images/hq_food2.jpg",
    "/images/hq_interior.jpg",
    "/images/hq_food1.jpg",
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setIdx((i) => (i + 1) % t.hero.slides.length);
    }, 5500);
    return () => clearInterval(timer);
  }, [t.hero.slides.length]);

  return (
    <section id="home" className="relative h-screen w-full overflow-hidden bg-charcoal">
      {t.hero.slides.map((s, i) => (
        <div key={i} className={`hero-slide ${i === idx ? "active" : ""}`}>
          <img src={heroImages[i]} alt={s.title} />
          <div className="hero-overlay" />
        </div>
      ))}

      <div className="pointer-events-none absolute top-24 left-6 w-24 h-24 border-t-2 border-l-2 border-[#D4A94A]/40 hidden md:block" />
      <div className="pointer-events-none absolute top-24 right-6 w-24 h-24 border-t-2 border-r-2 border-[#D4A94A]/40 hidden md:block" />

      <div className="relative z-10 h-full flex flex-col items-center justify-center text-center px-6">
        <div className="ornament mb-6 fade-in">
          <span className="font-display tracking-[0.4em] text-[#E9C97A] text-xs md:text-sm">{t.hero.namaste}</span>
        </div>
        <h1
          key={idx}
          className="font-display text-[#FFF7EA] text-5xl md:text-7xl lg:text-8xl font-bold leading-tight max-w-5xl fade-in-up"
          style={{ textShadow: "0 4px 30px rgba(0,0,0,0.6)" }}
        >
          {t.hero.slides[idx].title}
        </h1>
        <p
          key={`sub-${idx}`}
          className="mt-6 text-[#FBEFD9]/90 text-lg md:text-2xl max-w-3xl fade-in-up"
          style={{ animationDelay: "0.2s" }}
        >
          {t.hero.slides[idx].subtitle}
        </p>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-4 fade-in-up" style={{ animationDelay: "0.4s" }}>
          <a href={`tel:${restaurantInfo.phoneClean}`} className="btn-primary glow-orange">
            <Phone size={18} /> {t.hero.callBtn} · {restaurantInfo.phone}
          </a>
          <button onClick={onReserve} className="btn-outline">
            <UtensilsCrossed size={18} /> {t.hero.reserveBtn}
          </button>
          <a
            href="https://www.restablo.de/restaurant/puri-puri-flensburg.html"
            target="_blank"
            rel="noopener noreferrer"
            className="btn-outline"
          >
            <Truck size={18} /> {t.hero.deliveryBtn}
          </a>
        </div>

        <div className="absolute bottom-24 md:bottom-16 flex gap-2">
          {t.hero.slides.map((_, i) => (
            <button
              key={i}
              onClick={() => setIdx(i)}
              aria-label={`slide-${i}`}
              className={`h-1.5 rounded-full transition-all duration-500 ${
                i === idx ? "w-10 bg-[#E86D1F]" : "w-4 bg-[#FBEFD9]/40"
              }`}
            />
          ))}
        </div>

        <div className="scroll-indicator">
          <ChevronDown size={28} />
        </div>
      </div>
    </section>
  );
}
